module.exports = __webpack_public_path__ + "img/wechat_qrcode.e5dfef92.png";